import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { FacturaIndexComponent } from './FacturaIndex.component';
import { ResultadoEnvio } from './FacturaIndex.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
{
    path     : 'Factura',
    component: FacturaIndexComponent,
    canActivate: [RoleGuard], 
    data: { 
        formulario: 'Factura',
        nombreFormulario : 'Enviar Facturas'
    } 
}
];

@NgModule({
    declarations: [
    FacturaIndexComponent,
    ResultadoEnvio
    ],
    imports     : [
    SharedModule,
    RouterModule.forChild(routes)
    ],
    entryComponents: [
    ResultadoEnvio
    ],
    exports     : [
    FacturaIndexComponent
    ],
    bootstrap: [FacturaIndexComponent],
})

export class FacturaModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/EnviarFacturas/Factura.module.ts